<template>
  <div>
    <div class="w-full flex p-2 grow pt-0 flex-col overflow-auto">
      <div class="p-2 cursor-pointer border border-gray-200 text-gray-600 hover:bg-gray-50 duration-200 border-dashed rounded-lg flex items-center space-x-2" @click="selectingProducts = true">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 shrink-0" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
        </svg>
        <span>New product link</span>
      </div>
    </div>

    <portal-target name="body">
      <CatalogProductFinder
        v-model="selectingProducts"

        :multiple-select="true"
        :allow-search="true"
        :save-button="true"

        @save="saveSelectedSkus"
      >
        <template #save>
          Save products as link
        </template>
      </CatalogProductFinder>
    </portal-target>

    <portal-target name="body">
      <NamingSkusLink
        v-model="namingNewLink"
        @save="createCatalogLink"
      />
    </portal-target>
  </div>
</template>

<script>

import CatalogProductFinder from "@/components/SideEditor/Context/CatalogProductFinder"
import NamingSkusLink from "@/components/SideEditor/Context/NamingSkusLink"

export default {
  components: {
    NamingSkusLink,
    CatalogProductFinder,
  },
  data() {
    return {
      selectingProducts: false,
      namingNewLink: false,
      skus: [],
    }
  },
  methods: {
    createCatalogLink(name) {
      console.log(this.skus, name)
      this.$emit('create-catalog-link', { name, link: this.skus.map(sku => `sku[]=${sku}`).join("&") })
    },
    saveSelectedSkus(skus) {
      this.selectingProducts = false
      this.namingNewLink = true

      console.log(skus)
      this.skus = skus
    },
  },
}

</script>
